module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-bottom.2298f9db.svg";